export default __webpack_public_path__ + "static/media/Play-noFill.8c19a347.svg";